import React from 'react';
import LeadCard from './LeadCard';
import { Droppable } from '@hello-pangea/dnd';

const LeadsColumn = ({
    columnId,
    column,
    tasks,
    onAddTask,
    onEditTask,
    onDeleteTask,
    onDuplicateTask,
    onSkipLead,
    showPhone,
    showWhatsApp,
    loadMoreLeads,
    hasMore,
    loading,
    totalCounts,
    onReschedule
}) => {
    const lowercase = column?.title?.toLowerCase();

    return (
        <div className="w-33 kanban-item radius-12 bg-light border">
            <div className="card p-0 radius-12 overflow-hidden shadow-none">
                <div className="card-body p-3 pb-3">
                    <div className="d-flex align-items-center justify-content-between px-3 pb-3">
                        <h6 className="text-lg fw-semibold mb-0">{column.title}</h6>
                        <span className='badge text-bg-primary text-sm'>{totalCounts?.[lowercase === "in progress" ? "accepted" : lowercase]}</span>
                    </div>
                    <Droppable droppableId={column.id}>
                        {(provided, snapshot) => (
                            <div
                                className="connectedSortable ps-3 mt-3 pe-3"
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                style={{
                                    background: snapshot.isDraggingOver ? '#e3f2fd' : 'inherit',
                                    minHeight: '50px',
                                }}
                            >
                                {tasks.map((task, index) => (
                                    <LeadCard
                                        columnKey={columnId}
                                        key={task.id}
                                        task={task}
                                        index={index}
                                        onEdit={() => onEditTask(task.id, column.id)}
                                        onDelete={() => onDeleteTask(task.id, column.id)}
                                        onSkip={() => onSkipLead(task)}
                                        onDuplicate={() => onDuplicateTask(task.id, column.id)}
                                        showPhoneModal={() => showPhone(task)}
                                        showWhatsAppModal={() => showWhatsApp(task)}
                                        onReschedule={onReschedule}
                                    />
                                ))}
                                {provided.placeholder}
                                {!loading && tasks.length === 0 && (
                                    <div className="alert  text-center h-100-px d-flex justify-content-center align-items-center" role="alert">
                                        No Leads Found
                                    </div>
                                )}

                                {hasMore && (
                                    <button onClick={() => loadMoreLeads()} className="w-100 d-flex justify-content-center bg-secondary rounded-3 text-white py-2 text-sm mt-2 text-blue-500">
                                        {loading ? "Loading..." : "Load More"}
                                    </button>
                                )}
                            </div>
                        )}
                    </Droppable>
                </div>
            </div>
        </div>
    );
};

export default LeadsColumn;
